var render = function render(){var _vm=this,_c=_vm._self._c;return _c('new-policy-prompt',{attrs:{"dialog":_vm.dialog,"policy":_vm.policy},on:{"update:dialog":function($event){_vm.dialog=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }